import { base } from "../../common/config";
import axios from 'axios'

export const GetApplicationUserByPage = function (pageParam) {
    return axios({
        url: `${base}/api/Privilege/ApplicationUser/GetApplicationUserByPage`,
        method: 'POST',
        data: pageParam
    })
}

export const GetOne = function (Id) {
    return axios({
        url: `${base}/api/Privilege/ApplicationUser/GetOne?Id=${Id}`,
        method: 'GET'
    })
}

export const GetOneForEdit = function (Id) {
    return axios({
        url: `${base}/api/Privilege/ApplicationUser/GetOneForEdit?Id=${Id}`,
        method: 'GET'
    })
}

export const CreateApplicationUser = function (param) {
    return axios({
        url: `${base}/api/Privilege/ApplicationUser/Put`,
        method: 'POST',
        data: param
    })
}

export const UpdateApplicationUser = function (Id, param) {
    return axios({
        url: `${base}/api/Privilege/ApplicationUser/Post?Id=${Id}`,
        method: 'POST',
        data: param
    })
}

export const DeleteApplicationUser = function (Id) {
    return axios({
        url: `${base}/api/Privilege/ApplicationUser/Delete?Id=${Id}`,
        method: 'POST'
    })
}


export const GetAllApplicationUser = function (keywords) {
    keywords=keywords||'';
    return axios({
        url: `/api/Privilege/ApplicationUser/GetAllApplicationUser?keywords=${keywords}`,
        method:'GET'
    })
}



export const ChangePassword = function (param) {
    return axios({
        url: `${base}/api/Privilege/ApplicationUser/ChangePassword`,
        method: 'POST',
        data:param
    })
}


// WEBPACK FOOTER //
// ./src/api/privilege/application_user.js